if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
        this._ondaModalResizeHandler = () => {
          if (!this.hasAttribute('open')) return;
          const activeMedia = this.querySelector('[data-media-id].active');
          if (activeMedia) this.syncCloseButtonPosition(activeMedia);
        };
      }

      connectedCallback() {
        if (super.connectedCallback) super.connectedCallback();
        window.addEventListener('resize', this._ondaModalResizeHandler);
        window.addEventListener('orientationchange', this._ondaModalResizeHandler);
      }

      disconnectedCallback() {
        window.removeEventListener('resize', this._ondaModalResizeHandler);
        window.removeEventListener('orientationchange', this._ondaModalResizeHandler);
      }

      hide() {
        const closeButton = this.querySelector('.product-media-modal__toggle');
        if (closeButton) {
          closeButton.classList.remove('is-positioned');
          closeButton.setAttribute('aria-hidden', 'true');
          closeButton.style.removeProperty('--onda-modal-close-top');
          closeButton.style.removeProperty('--onda-modal-close-right');
        }
        super.hide();
      }

      show(opener) {
        const closeButton = this.querySelector('.product-media-modal__toggle');
        if (closeButton) {
          closeButton.classList.remove('is-positioned');
          closeButton.setAttribute('aria-hidden', 'true');
        }
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
        ).forEach((element) => {
          element.classList.remove('active');
        });
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');

        const container = this.querySelector('[role="document"]');
        if (container) {
          container.scrollTop = 0;
          container.scrollLeft = 0;
        }

        activeMedia.scrollIntoView({ block: 'center', inline: 'center' });
        this.syncCloseButtonPosition(activeMedia);
        requestAnimationFrame(() => this.syncCloseButtonPosition(activeMedia));
        setTimeout(() => this.syncCloseButtonPosition(activeMedia), 120);

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }

      syncCloseButtonPosition(activeMedia) {
        const closeButton = this.querySelector('.product-media-modal__toggle');
        if (!closeButton || !activeMedia) return;

        const target = activeMedia.matches('img, video, iframe, model-viewer')
          ? activeMedia
          : activeMedia.querySelector('img, video, iframe, model-viewer') || activeMedia;

        if (target.tagName === 'IMG' && !target.complete) {
          target.addEventListener('load', () => this.syncCloseButtonPosition(activeMedia), { once: true });
        }

        const rect = target.getBoundingClientRect();
        if (!rect.width || !rect.height) return;

        const inset = window.matchMedia('(max-width: 749px)').matches ? 8 : 10;
        const safeTop = Math.max(rect.top + inset, inset);
        const safeRight = Math.max(window.innerWidth - rect.right + inset, inset);

        closeButton.style.setProperty('--onda-modal-close-top', `${safeTop}px`);
        closeButton.style.setProperty('--onda-modal-close-right', `${safeRight}px`);
        closeButton.classList.add('is-positioned');
        closeButton.removeAttribute('aria-hidden');
      }
    }
  );
}
